import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { ExternalLink } from '../../external-link'

export const FooterNavItem = forwardRef((props, ref) => {
  const { as = 'li', children, href, ...rest } = props
  const Comp = as

  return (
    <Comp className="dev_dash__footer-nav-item" ref={ref} {...rest}>
      <ExternalLink className="dev_dash__footer-nav-item--link" href={href}>
        {children}
      </ExternalLink>
    </Comp>
  )
})

FooterNavItem.displayName = 'FooterNavItem'

FooterNavItem.propTypes = {
  as: PropTypes.any,
  href: PropTypes.string,
  children: PropTypes.any.isRequired,
}
